export const avatarPaths = {
  jersey: {
    viewBox: '0 0 400 400',
    content: ({ username = '', jerseyNumber = '00' }) => (
      <>
        {/* Base circle that takes user's color */}
        <circle 
          cx="200" 
          cy="200" 
          r="200" 
          fill="currentColor"
        />
        
        {/* Overlay details with opacity */}
        <g fill="#000000" opacity="0.32">
          <path d="M306.14514,54.97268l-45.4157-10.84025-.41191-.09832c-2.56473,2.60847-5.30663,5.05005-8.20665,7.30827-14.28136,11.12136-32.39481,17.77796-52.11087,17.77796s-37.83012-6.65685-52.11158-17.77847c-2.89971-2.25808-5.64141-4.6995-8.20604-7.30782l-.41186.09832-45.41565,10.8403c16.90199,145.02034-29.69249,188.31485-29.69249,188.31485v103.48807c35.6699,33.02758,83.39167,53.22443,135.83768,53.22443s100.16768-20.19684,135.83753-53.22437v-103.48812s-46.59448-43.29451-29.69244-188.31485Z" />
        </g>
        <g fill="#000000" opacity="0.32">
          <path d="M200,128.90295c33.57673,0,60.79607-36.35659,60.79607-81.2047,0-1.19581-.02808-2.38264-.06659-3.56583l-.41191-.09832c-2.56483,2.60847-5.30673,5.05005-8.20665,7.30827-14.28146,11.12136-32.39492,17.77796-52.11092,17.77796s-37.83012-6.65685-52.11158-17.77847c-2.89971-2.25808-5.64141-4.6995-8.20604-7.30782l-.41186.09832c-.03852,1.18314-.06659,2.37007-.06659,3.56588,0,44.84811,27.21934,81.2047,60.79607,81.2047Z" />
        </g>

         {/* Username text */}
        <text x="200" y="180" textAnchor="middle" className="font-bold uppercase" fill="white" fontSize="25">
          {username}
        </text>

        {/* Jersey number */}
        <text x="200" y="280" textAnchor="middle" className="font-extrabold" fill="white" fontSize="110">
          {jerseyNumber}
        </text>
      </>
    )
  }
};